import React from 'react';
type BoardMotifProps = {
  className?: string;
  size?: number;
};

/**
 * Esquina de tablero plano a 2 tonos — el motivo de portada del producto
 * (tomos DPS 39). Hereda el color via `currentColor`; tamaño y opacidad se
 * setean en el elemento.
 */
export function BoardMotif({
  className,
  size = 6
}: BoardMotifProps) {
  const cell = 240 / size;
  const squares: React.ReactNode[] = [];
  for (let r = 0; r < size; r++) {
    for (let c = 0; c < size; c++) {
      if ((r + c) % 2 === 0) {
        squares.push(<rect key={`${r}-${c}`} x={c * cell} y={r * cell} width={cell} height={cell} fill="currentColor" data-id="element-21" data-mp="3lkk6l1aafmvp" />);
      }
    }
  }
  return <svg viewBox="0 0 240 240" aria-hidden="true" className={className} data-id="element-22" data-mp="3btz06rodhe28">
      {squares}
      <rect x="1.5" y="1.5" width="237" height="237" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-23" data-mp="2xw0yalr8na3m" />
    </svg>;
}